import { FC } from "react";

import TableFiredEmployees from "../../../components/table/employees/TableFiredEmployees";

const FiredEmployees: FC = () => {
    return (
        <div style={{height: 'calc(100% - 37px)'}}>
            <TableFiredEmployees />
        </div>
    );
};

export default FiredEmployees;